import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/app-config.service';
import { Usuario, Contrasenia } from '../model/usuario';
import { ParametrosConst } from 'src/app/util/parametrosConst';
import { HttpClient } from '@angular/common/http';
import { share } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private conf: any;
  private url_acceder = '';
  private url_validarIngreso = '';
  private url_cambioContranenia = '';

  constructor(
    private _http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.conf = this.appConfigService.getConfig();
    this.url_acceder = this.conf.apiEndpoint + '/login';
    this.url_validarIngreso = this.conf.apiEndpoint + '/user/validarIngreso';
    this.url_cambioContranenia = this.conf.apiEndpoint + '/user/cambiarContrasenia';
  }

  verificarUsuario(_usuario: Usuario) {
    return this._http.post(this.url_acceder, {
      nombre: _usuario.usuario,
      password: _usuario.clave /*,
     "response":_usuario.capctcha*/
    }).pipe(share());
  }

  validarIngreso(_usuario: Usuario) {
    return this._http.post(this.url_validarIngreso, {
      nombre: _usuario.usuario,
      valor: _usuario.clave
    }).toPromise();
  }

  cambiarContrasenia(_contrasenia: Contrasenia) {
    _contrasenia.usuario = this.getCurrentSession().usuario;
    return this._http.post(this.url_cambioContranenia, _contrasenia).toPromise();
  }

  logout() {
    localStorage.removeItem(ParametrosConst.USUARIO_LOGIN);
    localStorage.removeItem(ParametrosConst.TOKEN);
    localStorage.removeItem(ParametrosConst.TOKEN_CLIENTE);
    localStorage.removeItem(ParametrosConst.USUARIO_CLIENTE);
    localStorage.removeItem(ParametrosConst.USUARIO_MENU);
  }

  getCurrentSession(): Usuario {
    const sessionStr = localStorage.getItem(ParametrosConst.USUARIO_LOGIN);
    return (sessionStr) ? JSON.parse(sessionStr) as Usuario : null;
  }
}

